import React from 'react'
import { svgImageNames } from 'src/enums'
import { useColorOrGrayscaleSVG } from 'src/hooks/brandHooks'
import { css } from 'styled-components'

interface NoPeopleProps {
  titleText: React.ReactNode
  topSubtitleText?: React.ReactNode
  bottomSubtitleText?: React.ReactElement
  buttonText?: React.ReactNode
  hideAdd?: boolean
}

const NoPeople: React.FC<NoPeopleProps> = (props) => {
  return (
    <div
      css={css`
        width: 40%;
        max-width: 400px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-self: center;
        align-items: center;
        margin-top: 40px;
        margin-bottom: 20px;
      `}
    >
      {useColorOrGrayscaleSVG(svgImageNames.NoUsers)}
      <span
        css={css`
          font-weight: bold;
          margin-bottom: 20px;
        `}
      >
        {props.titleText}
      </span>
      {props.topSubtitleText && (
        <span
          css={css`
            margin-bottom: 20px;
          `}
        >
          {props.topSubtitleText}
        </span>
      )}
      {props.bottomSubtitleText && (
        <span
          css={css`
            margin-bottom: 20px;
          `}
        >
          {props.bottomSubtitleText}
        </span>
      )}
    </div>
  )
}

export default NoPeople
